
export const Storage = {
    setItem:(key, value)=> {
        window.localStorage[key] = value;
    },
    getItem: (key) => {
        return window.localStorage[key] == undefined ? '' : window.localStorage[key];
    },
    setObject(key, value) {
        try {
            window.localStorage[key] = JSON.stringify(value);
        } catch (e) {
            alert('');
        }
    },
    getObject(key) {
        return JSON.parse(window.localStorage[key] || '{}');
    },
    getArray(key) {
        return JSON.parse(window.localStorage[key] || '[]');
    },
    removeItem(key) {
        window.localStorage.removeItem(key);
    },
    clear() {
        window.localStorage.clear();
    },
}

